module.exports = __webpack_public_path__ + "img/menu.ce8d39ac.png";